import { useRef, useState } from 'react';
import { DateRange, Range } from 'react-date-range';
import { addDays, format } from 'date-fns';
import cx from 'classnames';

import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import CalendarIcon from 'components/icons/CalendarIcon';
import ArrowRightIcon from 'components/icons/ArrowRightIcon';

import useClickAway from 'lib/hooks/use-click-away';
import { lastWeek } from 'utils/custom-static-ranges';
import { DateRangeStyles } from './date-range-picker-css';

import {
  StyledPicker,
  StyledOutputDateRange,
  StyledPickerButton,
  StyledPickerPopover,
  StyledPickerWrapper
} from './date-range-picker.style';

export const initialRange = {
  startDate: lastWeek.range().startDate,
  endDate: lastWeek.range().endDate,
  key: 'selection'
};

const FormatOutputDateRange = ({ stateRange }: { stateRange: Range }) => {
  let startDate = '';
  let endDate = '';

  if (stateRange?.startDate !== undefined) {
    startDate = format(stateRange.startDate, 'yyyy-MM-dd');
  }

  if (stateRange?.endDate !== undefined) {
    endDate = format(stateRange.endDate, 'yyyy-MM-dd');
  }

  return (
    <StyledOutputDateRange>
      <span>{startDate}</span>
      <ArrowRightIcon color="#d5d9e7" />
      <span>{endDate}</span>
      <CalendarIcon color="#d5d9e7" />
    </StyledOutputDateRange>
  );
};

const DatePicker = ({ onChange }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [isShowDatePicker, setShowDatePicker] = useState<boolean>(false);
  const [stateRange, setStateRange] = useState<Range>(initialRange);

  useClickAway(dropdownRef, () => setShowDatePicker(false));

  return (
    <StyledPickerWrapper>
      <StyledPicker
        className={cx({
          open: isShowDatePicker
        })}
        onClick={() => setShowDatePicker((isShow) => !isShow)}
      >
        <StyledPickerButton>
          <FormatOutputDateRange stateRange={stateRange} />
        </StyledPickerButton>
      </StyledPicker>

      {isShowDatePicker && (
        <StyledPickerPopover ref={dropdownRef}>
          <DateRange
            onChange={(key) => {
              setStateRange(key.selection);
              onChange({
                startDate: key.selection.startDate,
                endDate: addDays(new Date(key.selection.endDate), 1)
              });
            }}
            showMonthAndYearPickers={false}
            weekdayDisplayFormat="eeeeee"
            moveRangeOnFirstSelection={false}
            months={1}
            ranges={[stateRange]}
            direction="vertical"
            color="#6487ff"
            key="selection"
            showDateDisplay={false}
            minDate={new Date(2022, 6, 1)}
            maxDate={new Date()}
          />
        </StyledPickerPopover>
      )}

      <DateRangeStyles />
    </StyledPickerWrapper>
  );
};

export default DatePicker;
